/**
 * GET_ASSESSMENTS_SUMMARY_SUCCESS
 */
function* getAssessmentsSummarySuccess({ data }) {
  console.log('Success Assesments Summary', data)
}

export default getAssessmentsSummarySuccess
